export const contactFormTypes = {
  // Common Types
  UP_CONTACT_FORM_SEND: 'UP_CONTACT_FORM_SEND',
  // Front Types
  CONTACT_FORM_SET_NORMAL: 'CONTACT_FORM_SET_NORMAL',
  CONTACT_FORM_SET_PENDING: 'CONTACT_FORM_SET_PENDING',
  CONTACT_FORM_SET_SUCCESS: 'CONTACT_FORM_SET_SUCCESS',
  CONTACT_FORM_SET_ERROR: 'CONTACT_FORM_SET_ERROR',
};